class Monitoring.Models.ReplyBlacklist extends Backbone.Model
  urlRoot: '/keepcon/settings/account_setting/reply_blacklists'

  defaults:
    code: ''
    name: ''
    words: ''
    active: false
    content_visibility: 0

  sanitizedWords: ->
    if @get('words') instanceof(Array)
      @get('words').map((word) -> HtmlSanitizer.escapeHtml(word))
    else
      @get('words')

class Monitoring.Collections.ReplyBlacklistsCollection extends Backbone.Collection
  model: Monitoring.Models.ReplyBlacklist
  url: '/keepcon/settings/account_setting/reply_blacklists'
